<template>
  <ConfigurationMethodContainer>
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    <section id="subscription_container">
      <AddComponentModal
        ref="refAddComponent"
        @updateComponent="updateComponent"
        @pushComponent="pushComponent"
      />
      <div class="grid-columns"> 
        <div class="column">
          <CompanySelector v-model="company" v-validate="'required'" placeholder="Seleccione una empresa"
                name="company" />
        </div>
        <div class="column">
          <b-field label="Método de pago">
            <b-select
              name="methodType"
              v-model="methodType"
              v-validate="'required'"
              expanded
            >
              <option value="">Seleccione</option>
              <option value="-99">+ Agregar nuevo</option>
              <option
                v-for="option in methodsList"
                :value="option.code"
                :key="option.code"
                :id="option.code"
              >
                {{ option.title }}
              </option>
            </b-select>
          </b-field>
          <span class="show-error">{{ errors.first("methodType") }}</span>
        </div>
        <div class="column mt-button">
          <vs-button
            @click="addComponent"
            color="primary"
            class="pl-5 pr-5"
            type="filled"
            icon="add"
          >
            Agregar componente
          </vs-button>
        </div>
      </div>

      <fieldset class="fieldset" v-if="methodType === '-99'">
        <legend>Información del nuevo método de pago</legend>
        <div class="grid-columns">
          <div class="column">
            <b-field label="Título">
              <b-input
                placeholder="Título"
                type="text"
                name="title"
                v-model="title"
                v-validate="'required'"
              />
            </b-field>
            <span class="show-error">{{ errors.first("title") }}</span>
          </div>
          <div class="column">
            <b-field label="Código">
              <b-input
                placeholder="Código unidad"
                type="text"
                name="initials"
                v-model="initials"
                v-validate="'required'"
              />
            </b-field>
            <span class="show-error">{{ errors.first("initials") }}</span>
          </div>
        </div>
      </fieldset>

      <fieldset class="fieldset" v-if="listComponents.length > 0">
        <legend>Campos dinámicos</legend>
        <div class="grid-columns">
          <div
            v-for="(field, index) in listComponents"
            :key="field.key"
            :id="field.key"
            :class="field.hide ? 'hide' : ''"
          >
            <div class="column" v-if="!field.hide">
              <dinamyc-field
                @removeAction="removeField"
                :showRemoveAction="true"
                v-bind:field="field"
                v-bind:index="index"
                v-bind:dynamicFields="dynamicFields"
                v-bind:dinamycValueFields="dinamycValueFields"
                @onChange="onChangeValue"
              />
            </div>
          </div>
        </div>
      </fieldset>
      <div class="columns">
        <div class="column">
          <vs-button
            color="primary"
            class="pl-5 pr-5"
            type="filled"
            icon="saved"
            @click="saveConfiguration"
          >
            Guardar configuración
          </vs-button>
        </div>
      </div>
    </section>
  </ConfigurationMethodContainer>
</template>

<script>
import { ROUTES } from "../../../global/api_routes";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { configToast, TOAST_TYPES } from "../../../global/toast";
import ConfigurationMethodContainer from "./styles";
import { confirmation } from "../../../global/utils";
import AddComponentModal from "./AddComponentModal.vue";
import DinamycField from "../../devices/configuration/DinamycField.vue";
import CompanySelector from "../../../components/Shared/CompanySelector";

export default {
  name: "Subcription",
  components: {
    Treeselect,
    ConfigurationMethodContainer,
    AddComponentModal,
    DinamycField,
    CompanySelector,
  },
  data: () => ({ 
    company:null,
    actualCode: null,
    dynamicFields: {},
    dinamycValueFields: {},
    isLoading: false,
    actualCode: null,
    methodRecords: [],
    methodsList: [],
    methodType: "",
    title: null,
    initials: null,
    listComponents: [],
    showTitle: false,
  }),
  mounted() {
    this.isLoading = true;
    this.getPaymentMethods();
  },
  watch: {
    methodType() {
      if (!this.methodType) {
        return;
      }
      this.getMethodProps();
    },
  },
  methods: {
    getMethodProps() {
      this.isLoading = true;
      this.$http
        .get(ROUTES.DASHBOARD.PAY_METHODS.GET_METHOD_PROPS, {
          params: {
            payMethodCode: this.methodType,
          },
        })
        .then(({ data }) => {
          if (data.code > 0) {
            try {
              this.actualCode = data.info.code;
              this.listComponents = JSON.parse(data.info.fields);
            } catch (error) {}
            return;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    clear() {
      this.title = null;
      this.method = "";
      this.methodType = "";
      this.initials = null;
      this.listComponents = [];
    },
    onChangeValue(change) {
      console.log(change);
    },
    saveConfiguration() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.toast("Completa el formulario", TOAST_TYPES.ERROR);
          return;
        }
        this.sendConfiguration();
      });
    },
    sendConfiguration() {
      this.isLoading = true;
      this.$http
        .post(ROUTES.DASHBOARD.PAY_METHODS.SAVE_CONFIGURATION, {
          code: this.actualCode,
          methodType:
            this.methodType === "-99"
              ? { title: this.title, initials: this.initials }
              : this.methodType,
          fields: JSON.stringify(this.listComponents),
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.toast(
              "Se ha registrado la configuración del método de pago correctamente.",
              TOAST_TYPES.SUCCESS
            );
            this.clear();
            return;
          }
          this.toast(data.message, TOAST_TYPES.ERROR);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    pushComponent(component) {
      //Verificamos que no exista el mismo key...
      const exists = this.listComponents.find((c) => c.key === component.key);
      if (exists) {
        this.toast(
          "El nombre [name] del componente debe ser único.",
          TOAST_TYPES.ERROR
        );
        return;
      }
      this.listComponents = [...this.listComponents, component];
    },
    removeField(component) {
      confirmation(
        this,
        `¿Deseas eliminar el componente "${component.title}?`
      ).then((result) => {
        if (!result) {
          return;
        }
        this.listComponents = this.listComponents.filter(
          (c) => c.key !== component.key
        );
      });
    },
    addComponent() {
      this.$refs.refAddComponent.openModal();
    },
    updateComponent(component) {
      console.log("Component:", component);
    },
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#subscription_container");
      return instance.open(message, type);
    },
    getCompanies() {
      this.$http
        .get(ROUTES.DASHBOARD.GET_COMPANIES_TREE_V1)
        .then(({ data }) => {
          if (data.code > 0) {
            this.companies = data.info;
            this.processData(this.companies);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    processData(companies) {
      for (let index = 0; index < companies.length; index++) {
        let companie = companies[index];
        companie.label = companie.name;
        companie.id = companie.code;
        if (companie.children) {
          this.processData(companie.children);
        }
      }
    },
    getPaymentMethods() {
      try {
        this.isLoading = true;
        this.$http
          .get(ROUTES.DASHBOARD.ENTITY.ALL_PAYMENT_METHODS, {
            params: {
              kindId: 3,
            }
          })
          .then(({ data }) => {
            this.isLoading = false;
            if (data.code > 0) {
              this.methodsList = data.info;
              return;
            }
            this.methodsList = [];
          });
      } catch (error) {
        this.isLoading = false;
        this.toast(error, TOAST_TYPES.ERROR);
      }
    },
  },
};
</script>
